<template>
  <div class="flow-text" id="home-banner">
    <!-- <div id="image-banner">
      <div class="row flow-text">
        <div class="col s3">Harrisen Sanchez</div>
        <div class="col s5"></div>
        <div class="col s4">
          <ul>
            <li>
              <router-link class="nav-link" :to="{name: 'OtherHomePage'}" exact>Home</router-link>
            </li>|
            <li>
              <router-link class="nav-link" :to="{name: 'WorksPage'}" exact>Works</router-link>
            </li>|
            <li>
              <router-link class="nav-link" :to="{name: 'AboutPage'}" exact>About</router-link>
            </li>|
            <li>
              <router-link class="nav-link" :to="{name: 'OtherHomePage'}" exact>Extra</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>-->

    <!-- <div class="container"></div> -->

    <div class="centered">
      <h2>Harrisen Sanchez</h2>
      <div class="container">
        <div class="row">
          <div class="col s3"></div>
          <div class="col s3" v-for="(social, index) in items" :key="index">
            <div class="social-item">
              <a :href="social.URL" target="_blank">
                <i :class="social.className"></i>
              </a>
            </div>
          </div>
          <div class="col s3"></div>
        </div>
      </div>
    </div>
    <div class="top-mid home-nav-link-active">Home</div>
    <div class="left-mid">
      <router-link class="home-nav-link" :to="{name: 'EnterpriseProjectsPage'}" exact>Works</router-link>
    </div>
    <div class="right-mid">
      <router-link class="home-nav-link" :to="{name: 'AboutPage'}" exact>About</router-link>
    </div>
    <!-- <div class="bottom-mid">
      <router-link class="home-nav-link" :to="{name: 'ExtraPage'}" exact>Extra</router-link>
    </div>-->
    <!-- <Footer /> -->
    <footer class="page-footer">
      <div class="footer-copyright">
        <div class="flow-text">
          <div class="row">
            <div class="footer-item col l3">©2019 Harrisen Sanchez</div>
            <div id="footer-tags">
              <div class="footer-item col l3">(562)-316-7743</div>
              <div class="footer-item col l3">hmsanchez98@gmail.com</div>
              <div class="footer-item col l3"></div>
              <a
                href="https://drive.google.com/open?id=1GOADqfCuoX2rgT0aqU1gNNjbtm6k6i5S"
                target="_blank"
                class="text-modal"
              >View Resume</a>
            </div>
            <div class="col s4">
              <a class="modal-trigger" id="modal-toggle" href="#modal1">More Info</a>
              <div id="modal1" class="modal">
                <div class="modal-content">
                  <h4>Info</h4>
                  <div class="row">
                    <div class="footer-item col s12">(562)-316-7743</div>
                    <div class="footer-item col s12">hmsanchez98@gmail.com</div>
                    <div class="footer-item col s12"></div>
                    <a
                      href="https://drive.google.com/open?id=1GOADqfCuoX2rgT0aqU1gNNjbtm6k6i5S"
                      target="_blank"
                      class="text-modal"
                    >View Resume</a>
                  </div>
                </div>
                <div class="modal-footer">
                  <a href="#!" class="modal-close waves-effect waves-green btn-flat">Close</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  name: "OtherHomePage",
  components: {
    Footer
  },
  data() {
    return {
      items: [
        {
          name: "LinkedIn",
          className: "fab fa-linkedin",
          URL: "https://www.linkedin.com/in/harrisen-sanchez-786541182"
        },
        {
          name: "Github",
          className: "fab fa-github-square",
          URL: "https://github.com/HMSanchez"
        }
      ]
    };
  },
  mounted() {
    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll(".modal");
      var instances = M.Modal.init(elems, {});
    });
  }
};
</script>

<style>
#home-banner {
  /* background-image: url("/Logo.png");  
  background-repeat: no-repeat, repeat;
  text-align: center;
  justify-content: center;
  position: relative;
  background-size: 400px;
  background-position: center;
  background-attachment: fixed; */
  text-align: center;
}
.modal-content {
  color: #2e353b;
}
#modal-toggle {
  color: #c1c9c7;
  text-decoration: underline;
}
#modal-toggle:hover {
  cursor: pointer;
  color: rgba(193, 201, 199, 0.589);
}
/* @media screen and (max-width: 550px) {
  .top-mid{
    margin-left: -25px; 
  }
} */

.page-footer {
  margin-top: 20px;
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding: 0px;
  background-color: rgb(121, 17, 17);
  clear: both;
}
.centered {
  position: fixed;
  letter-spacing: 2px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.top-mid {
  /* position: fixed; */
  top: 8px;
  /* left: 50%;
  right: auto; */
  /* margin-left: -35px; */
}
.left-mid {
  position: fixed;
  top: 45%;
  left: 0px;
}
.right-mid {
  position: fixed;
  top: 45%;
  right: 0px;
}
.bottom-mid {
  position: fixed;
  bottom: 8px;
  left: 50%;
  margin-left: -35px;
}

.home-nav-link {
  color: #a60512;
  padding: 15px;
}
.home-nav-link:hover {
  color: #2e353b;
}
ul {
  margin: 0px;
}
ul li {
  display: inline-block;
  padding: 2px;
  margin: 2px;
}
.home-nav-link-active {
  text-decoration: underline;
  color: #a60512;
}
.social-item a {
  color: #2e353b;
}
.social-item a:hover {
  color: #2e353bb2;
}
</style>
